import { useMemo, useState } from 'react'
import * as ClientHttp from '../../services/api/https/registration/client.http'
import { errorHandler } from '../../services/util/error.service'

const MIN_SIZE_PASSWORD = 5

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SEND_EMAIL: 'Enviando email de redefinição de senha',
  CHANGE_PASSWORD: 'Alterando senha',
  SUCCESS: 'Sucesso',
}

const INITIAL_STATE = {
  userCredentials: {
    email: '',
    senha: '',
    confirmarSenha: '',
  },
  token: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  isLoading: false,
  errorMessage: null,
}

export default function useForgotPassword() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      sendEmail(email) {
        ClientHttp.sendEmailRetrievePassword(email)
          .then(res =>
            setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SUCCESS })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      changePassword(token, password) {
        ClientHttp.changePassword(token, password)
          .then(res =>
            setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SUCCESS })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      resetState() {
        setState({ ...INITIAL_STATE })
      },

      // Events
      onChangePassword(senha, confirmarSenha) {
        if (senha.length < MIN_SIZE_PASSWORD || confirmarSenha < MIN_SIZE_PASSWORD) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'A Senha deve ter 8 ou mais caracteres',
          }))
        } else if (senha !== confirmarSenha) {
          setState(prevState => ({ ...prevState, errorMessage: 'As senhas não conferem.' }))
        } else
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.CHANGE_PASSWORD }))
      },

      onRetrivePassword() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SEND_EMAIL }))
      },

      onChange(name, value) {
        setState(prevState => {
          prevState.userCredentials[name] = value
          return { ...prevState }
        })
      },

      getQueryParams(query = null) {
        return (
          (query || window.location.search.replace('?', ''))

            // get array of KeyValue pairs
            .split('&')

            // Decode values
            .map(pair => {
              let [key, val] = pair.split('=')

              return [key, decodeURIComponent(val || '')]
            })

            // array to object
            .reduce((result, [key, val]) => {
              result[key] = val
              return result
            }, {})
        )
      },

      onInit(token) {
        setState(prevState => ({ ...prevState, token: token }))
      },
    }
  }, [])

  return { state, localDispatch }
}
